var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"text-center text-lg"},[_c('div',{staticClass:"circle",class:{ 'circle--online': _vm.online }})])
}
var staticRenderFns = []

export { render, staticRenderFns }